export default __webpack_public_path__ + "static/media/closet5-after3-480w.a9d4c9c6.avif";